import { Component, OnInit } from '@angular/core';
import { SubscriptionFilter, SubscriptionModel, SubscriptionServiceProxy } from '../../../../shared/service-proxies/event-service-proxy';
import { TableColumn } from '../../../interfaces/table-column.interface';
import { Router } from '@angular/router';
import { FilterService } from '../../../services/filter/filter.service';
import { DestroyService } from '../../../services/destroy/destroy.service';
import { takeUntil } from 'rxjs';
import { ErrorService } from '../../../services/error/error.service';

@Component({
    selector: 'app-account-list-page',
    templateUrl: './account-list-page.component.html',
    styleUrl: './account-list-page.component.scss',
    providers: [DestroyService],
    standalone: false
})
export class AccountListPageComponent implements OnInit {
  public subscriptionsFilter: SubscriptionFilter  = new SubscriptionFilter();
  public subscriptions: SubscriptionModel[] = [];
  public activeFilters: number = 0; 
  public columns: TableColumn[] = [
    { header: 'Логин', field: 'login', col: 2, isCopyable: true },
    { header: 'Пароль', field: 'password', col: 2, isCopyable: true },
    { header: 'Товар', field: 'orderProduct.name', col: 3 },
    { header: 'Цена', field: 'orderProduct.price', col: 2 },
    { header: 'Создан', field: 'createdAt', col: 3 },
    { header: 'Активирован', field: 'activatedAt', col: 3 },
    { header: 'Заканчивается', field: 'expiresAt', col: 3 },
    { header: 'Смотрел', field: 'lastSeenAt', col: 4},
    { header: '', field: 'isActive', col: 4 },
     { header: '', field: 'btnProlong', col: 4, isPagination: true },
  ];

  activeFilter: boolean = false;
  dataMissing: boolean|string = false;

  isLoading: boolean = true;

  currentPage: number = 1;
  pageSize: number = 15;
  totalItems: number = 0;

  constructor(private errorService: ErrorService, private _subscriptionService: SubscriptionServiceProxy, private filterService: FilterService, private router: Router, private destroyService: DestroyService) { }

  ngOnInit(): void {
    this.getFilterState()
    this.getSubscriptions()
  }
  
  getSubscriptions() {
    this.subscriptionsFilter.page = this.currentPage;
    this.subscriptionsFilter.perPage = this.pageSize;
    this._subscriptionService.getSubscriptions(this.subscriptionsFilter)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe((subscriptions) => {
      this.subscriptions = subscriptions.items;
      this.totalItems = subscriptions.total; 
      this.isLoading = false;
      this.dataMissing = this.subscriptions.length == 0;
      console.log(this.subscriptions);
        
    }, error => {
        console.error(error);
        this.isLoading = false;
        this.dataMissing = 'Не удалось получить список подписок. Попробуйте позже.';
        this.errorService.handleError(error, 'Не удалось получить список подписок. Попробуйте позже.');
    }
    )
  }

   getFilterState() {
    const currentUrl = this.router.url;
     this.filterService.getFilterState(currentUrl)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe((state) => {
      this.activeFilter = state; 
    });
  }

  onPageChange(newPage: number): void {
    this.currentPage = newPage;
    this.getSubscriptions();
  }

  onFilterApply(filter: SubscriptionFilter): void {
    this.subscriptionsFilter = filter;
    this.currentPage = 1; 
    this.getSubscriptions();
  }
  
  onFilterReset(): void {
    this.subscriptionsFilter = new SubscriptionFilter(); 
    this.currentPage = 1; 
    this.getSubscriptions();
  }

  activeFiltersVisible: boolean = false;

  onActiveFiltersVisible(event: boolean) {
    this.activeFiltersVisible = event;
    console.log(this.activeFiltersVisible);
    
  }

  activeFiltersCount: number = 0;

  changeActiveFiltersCount() {
    let count = 0;

    if (this.subscriptionsFilter?.login) count++;
    if (this.subscriptionsFilter?.password) count++;
    if (this.subscriptionsFilter?.isActive !== undefined) count++;
    if (this.subscriptionsFilter?.providerId) count++;
    if (this.subscriptionsFilter?.products && this.subscriptionsFilter.products.length > 0) count++;
    if (this.subscriptionsFilter?.activatedFrom || this.subscriptionsFilter?.activatedTo) count++;
    if (this.subscriptionsFilter?.expiresFrom || this.subscriptionsFilter?.expiresTo) count++;
    if (this.subscriptionsFilter?.lastSeenFrom || this.subscriptionsFilter?.lastSeenTo) count++;

    this.activeFiltersCount = count;
  }

}
